import "./CustomerDashboard.css";
import React, { useEffect, useMemo, useState } from "react";
import { createB2BAPI } from "./api/Interceptor";
import { IconEye, IconEyeOff, IconHeartFilled, IconHistoryOff, IconRibbonHealth } from "@tabler/icons-react";
import { IconHeart, IconSquareRoundedPlus } from "@tabler/icons-react";
import { Carousel, CarouselSlide } from "@mantine/carousel";
import { useLocation, useNavigate } from "react-router-dom";
import downloadApp from "./assets/DownloadAppLogo.svg";
import {
  ActionIcon,
  Button,
  Card,
  Checkbox,
  ColorSwatch,
  Group,
  Input,
  Loader,
  Modal,
  PasswordInput,
  Select,
  Stack,
  Tabs,
} from "@mantine/core";

import _, { set, size } from "lodash";
import silkImage from "./assets/silk.jpg";
import { BASE_URL } from "./api/EndPoints";
import badge from "./assets/badge.png";
import B2BButton from "./components/common/B2BButton";
import PaymentDetailPage from "./components/customer/orders/PaymentDetailPage";
import moment from "moment/moment";
import notify from "./utils/Notification";
import PayNow from "./PayNow";
import { useMediaQuery } from "@mantine/hooks";
import { colors } from "@mui/material";
import { FaBeer, FaRibbon, FaTag } from "react-icons/fa";
import { COMPANY_NAME, KEY_PAYMENT } from "./api/PaymentKey";

const FALLBACK_IMAGE = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Crect width='200' height='200' fill='%23f1f5f9'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='sans-serif' font-size='14' fill='%2394a3b8'%3EImage Unavailable%3C/text%3E%3C/svg%3E";

const CustomerDashboard = () => {
  const navigate = useNavigate();
  const [wishList, setWishList] = useState([]);
  const [recomend, setRecomend] = useState([]);
  const [profile, setProfile] = useState(null);
  console.log(wishList, "profile ")
  const [loyalty, setLoyalty] = useState(null);
  const [collectionTop, setCollectionTop] = useState({});
  const [collectionBottom, setCollectionBottom] = useState({});
  const [pimVariantIds, setPimVariantIds] = useState([]);
  const [order, setOrder] = useState([]);
  const [orders, setOrders] = useState([]);
  const [paymentOpened, setPaymentOpened] = useState(false);
  const [payment, setPayment] = useState([]);
  const [paymentPage, setPaymentPage] = useState(0);
  const [hasMorePayments, setHasMorePayments] = useState(true);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentLoader, setPaymentLoader] = useState(false);
  const [activeCancelOrder, setActiveCancelOrder] = useState(null);
  const [allOrdersByStatus, setAllOrdersByStatus] = useState({});
  const [isTransactionUploaded, setIsTransactionUploaded] = useState({});
  const [hasMore, setHasMore] = useState(true);
  const [collectionsLoaded, setCollectionsLoaded] = useState(false);
  const [dashBoardGetAll, setDashBoardGetAll] = useState(false);
  const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
  const [showToast, setShowToast] = useState(false);
  const [groupList, setGrouplist] = useState({});
  const [page, setPage] = useState(0);
  const collectionsArray = Object.values(collectionTop);
  const collectionsBottomArray = Object.values(collectionBottom);
  const [chanagePasswordOpened, setChangePasswordOpened] = useState(false)
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPasswords, setShowPasswords] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const [customerWalletDetails, setCustomerWalletDetails] = useState({})
  const closeSecondModal = () => {
    setChangePasswordOpened(false);

  };
  console.log(order, "km")
  const [loadingCount, setLoadingCount] = useState(0);
  console.log(customerId, "customerId ")
  const startLoading = () => setLoadingCount((prev) => prev + 1);
  const stopLoading = () => setLoadingCount((prev) => prev - 1);

  const loading = loadingCount > 0;
  const navigateToOrders = (orderType) => {
    switch (orderType) {
      case "WHOLESALE":
        return "/place-Orders";
      case "SAMPLE":
        return "/place-Sample";
      case "SWATCH":
        return "/place-Swatch";
      default:
        return "/place-Orders";
    }
  };

  useEffect(() => {
    getCustomerWalletDetails(profile?.customerId)
  }, [profile])
  const getCustomerWalletDetails = async (id) => {
    if (profile?.customerId === (null || undefined)) {
      return
    }
    const res = await B2B_API.get(`loyalty/customerWalletDashboard?id=${profile?.customerId === undefined ? id : profile?.customerId}`).json();
    setCustomerWalletDetails(res.response)
  }

  const [salesOrder, setSalesOrder] = useState({
    paymentHistory: {},
  });
  const isMobile = useMediaQuery("(max-width: 767px)");
  const variantOptions = [
    "NEW",
    "CONFIRMED",
    "PACKED",
    "INVOICED",
    "SHIPPED",
    "DELIVERED",
    "CANCELLED",
    "RETURNED",
  ];
  const [activeTab, setActiveTab] = useState(
    location?.state?.activeTabFromLocation || variantOptions[0]
  );

  useEffect(() => {
    fetchWishList();
    fetchWishListPImIds();
    fetchAll();
    featchProfile()

  }, []);

  const paymentClose = () => {
    setPaymentOpened(false);
    setSalesOrder({ payment: {} });
  };
  const timeSince = (previousLoginDate) => {
    const now = Date.now();
    const diffMs = now - previousLoginDate;

    if (diffMs < 0) return "in the future";

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (seconds < 60) {
      return "just now";
    } else if (minutes < 60) {
      return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
    } else if (hours < 24) {
      return `${hours} hour${hours === 1 ? "" : "s"} ago`;
    } else {
      return `${days} day${days === 1 ? "" : "s"} ago`;
    }
  };
  const handleSubmit = () => {
    if (!oldPassword || !newPassword || !confirmPassword) {
      alert("Please fill all fields.");
      return;
    }
    if (newPassword !== confirmPassword) {
      alert("New passwords do not match.");
      return;
    }
    closeSecondModal();
  };

  const AcceptPaymentt = async () => {
    try {
      if (salesOrder?.paymentHistory?.accountNo !== salesOrder?.paymentHistory?.confirmAccountNo) {
        notify({
          error: true,
          success: false,
          title: 'Confirm Account No mismatch with Account No'
        });
        return;
      }
      const { referenceNo, adjustmentType } = salesOrder;
      const url =
        adjustmentType === "DC"
          ? `receipt/update-payment?receiptNo=${referenceNo}`
          : `order/update-payment?orderNo=${referenceNo}`;
      const res = await B2B_API.post(url, {
        json: {
          ...salesOrder?.paymentHistory,
          depositAmount: salesOrder?.payment?.PayAmount || 0,
        },
      });
      notify({
        error: false,
        success: true,
        title: "Payment received waiting for approval",
      });
      fetchAllOrders();
      paymentClose();
      fetchAll();
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    } catch (error) {
      notify({
        error: true,
        success: false,
        title: error?.message || "Something went wrong",
      });
    }
  };
  useEffect(() => {
    if (location?.state?.activeTabFromLocation) {
      setActiveTab(location?.state?.activeTabFromLocation);
    }
  }, [location]);
  const handleTabChange = (option) => {
    setActiveTab(option);
  };
  const handleClickOutside = (event) => {
    if (event.target.classList.contains("modal-backdrop")) {
      setActiveCancelOrder(null);
    }
  };
  const counts = useMemo(() => {
    return variantOptions.reduce((acc, status) => {
      acc[status] = allOrdersByStatus[status]?.length || 0;
      return acc;
    }, {});
  }, [allOrdersByStatus]);
  useEffect(() => {
    if (activeCancelOrder) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [activeCancelOrder]);
  const fetchLoyalty = async () => {
    if (!profile?.loyaltyId) {
      return
    }
    startLoading();
    try {

      const res = await B2B_API.get(`loyalty/loyaltyId?loyaltyId=${profile?.loyaltyId}`).json();
      setLoyalty(res.response);
    } catch (error) {
      console.error("Error fetching recommended items:", error);
    } finally {
      stopLoading();
    }
  }
  useEffect(() => {
    if (profile?.loyaltyId) {
      fetchLoyalty();
    }

  }, [profile?.loyaltyId])

  const acceptPayment = async (order) => {
    try {
      const res = await B2B_API.get("customer/profile").json();
      const { companyName, mobileNo, email } = res?.response
      const { receiptNo, orderNo } = order;

      const url = receiptNo
        ? `onlinePayment/create_for_dc?orderId=${receiptNo}`
        : `onlinePayment/create_for_order?orderId=${orderNo}`;
      // Step 1: Create payment order from backend
      const createOrderRes = await B2B_API.post(url).json();
      const orderData = createOrderRes;

      if (!orderData || !orderData.orderId) {
        throw new Error('Failed to create Razorpay order');
      }

      // Step 2: Load Razorpay script
      const loadScript = (src) =>
        new Promise((resolve) => {
          const script = document.createElement("script");
          script.src = src;
          script.onload = () => resolve(true);
          script.onerror = () => resolve(false);
          document.body.appendChild(script);
        });

      const isRazorpayLoaded = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

      if (!isRazorpayLoaded) {
        alert("Failed to load Razorpay SDK. Please check your internet.");
        return;
      }

      // Step 3: Open Razorpay modal
      const options = {
        key: KEY_PAYMENT,
        amount: orderData.amount * 100,
        currency: orderData.currency,
        name: COMPANY_NAME,
        description: orderData.description,
        order_id: orderData.orderId,
        handler: async function (response) {
          const { razorpay_order_id, razorpay_payment_id, razorpay_signature } = response;

          // Step 1: Verify payment on backend
          const verifyRes = await B2B_API.post(`onlinePayment/verify?razorpayOrderId=${razorpay_order_id}&razorpayPaymentId=${razorpay_payment_id}&razorpaySignature=${razorpay_signature}`, { json: null }).json();

          const verified = verifyRes;
          if (!verified) {
            alert("❌ Payment verification failed");
            return;
          }

          // Step 4: Call backend to update payment
          const url = receiptNo
            ? `receipt/update-payment?receiptNo=${receiptNo}`
            : `order/update-payment?orderNo=${orderNo}`;

          // await B2B_API.post(url, {
          //   ...salesOrder?.paymentHistory,
          //   depositAmount: salesOrder?.payment?.amountNeedToBePaid || 0,
          // });

          notify({
            error: false,
            success: true,
            title: "Payment received, waiting for approval",
          });
          fetchAllOrders();
          fetchAll();
          paymentClose();
          setShowToast(true);
          setTimeout(() => setShowToast(false), 3000);
        },
        prefill: {
          name: companyName,
          email: email,
          contact: mobileNo,
        },
        theme: {
          color: "#3399cc",
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();

    } catch (error) {
      console.error("Payment failed", error);
      notify({
        error: true,
        title: error.message,
      });
    }
  };
  const handleConfirmCancel = async (receiptNo) => {
    try {
      const url = receiptNo?.receiptNo
        ? `receipt/confirm-order`
        : `order/confirm-order`;
      let body = {};
      if (receiptNo?.receiptNo) {
        body = {
          receiptNo: receiptNo?.receiptNo,
          orderStatus: "CANCELLED",
        };
      } else {
        body = {
          orderNo: receiptNo?.orderNo,
          orderStatus: "CANCELLED",
        };
      }
      await B2B_API.post(url, { json: body });
      setActiveCancelOrder(null);
      fetchAllOrders();
      setPage(0);
      setHasMore(true);
    } catch (error) {
      console.error("Error canceling order:", error);
    }
  };
  useEffect(() => {
    fetchAllOrdersForCounts();
  }, []);

  const paymentOpen = (orderItem) => {
    setSalesOrder({
      ...orderItem,
      payment: {
        ...orderItem.payment,
        PayAmount: orderItem?.totalAmount ?? 0,
      },
    });
    setPaymentOpened(true);
  };

  const fetchWishList = async () => {
    startLoading();
    try {
      const res = await B2B_API.get("wishlist/all").json();
      setWishList(res.response || []);
    } catch (error) {
      console.error("Error fetching wishlist:", error);
    }
    finally {
      stopLoading();
    }
  };
  const fetchWishListPImIds = async () => {
    try {
      const res = await B2B_API.get("wishlist/pim-ids").json();
      setPimVariantIds(res.response);
    } catch (error) { }
  };

  useEffect(() => {
    setGrouplist({});
    fetchAllOrders();
  }, [activeTab, page]);

  const fetchAllOrdersForCounts = async () => {
    const statuses = [
      "NEW",
      "CONFIRMED",
      "PACKED",
      "INVOICED",
      "SHIPPED",
      "DELIVERED",
      "CANCELLED",
      "RETURNED",
    ];
    const allOrders = {};

    for (const status of statuses) {
      startLoading();
      try {
        let res;
        if (status === "RETURNED") {
          res = await B2B_API.get(
            `return/all/customer?orderStatus=${status}&page=0&pageSize=10`
          );
        } else if (status === "CANCELLED") {
          res = await B2B_API.get(
            `order/allByStatus?orderStatus=${status}&page=0&pageSize=10`
          );
        } else if (status === "NEW") {
          const newOrder = {
            fetchCancelled: false,
            fetchDelivered: false,
            fetchInvoice: false,
            fetchNewOrder: true,
            fetchPacked: false,
            fetchShipped: false,
            fromDate: null,
            search: "",
            status: "NEW",
            toDate: new Date(),
          };
          const searchOrder = { ...newOrder };
          searchOrder.fromDate = _.isDate(searchOrder.fromDate)
            ? moment(searchOrder.fromDate).format("DD/MM/YYYY")
            : null;
          searchOrder.toDate = _.isDate(searchOrder.toDate)
            ? moment(searchOrder.toDate).format("DD/MM/YYYY")
            : null;

          res = await B2B_API.post(`order/search?page=0&pageSize=10`, {
            json: searchOrder,
          });
        } else {
          res = await B2B_API.get(
            `receipt/allByStatus?orderStatus=${status}&page=0&pageSize=10`
          );
        }

        const data = await res.json();
        const filteredData = data?.response?.content || [];
        allOrders[status] = filteredData;
      } catch (error) {
        console.error(`Error fetching ${status} orders:`, error);
        allOrders[status] = [];
      }
      finally {
        stopLoading();
      }
    }

    setAllOrdersByStatus(allOrders);
  };
  const fetchAllOrders = async () => {
    if (!hasMore || loading) return;
    startLoading();
    try {
      let res;
      if (activeTab === "NEW") {
        const newOrder = {
          fetchCancelled: false,
          fetchDelivered: false,
          fetchInvoice: false,
          fetchNewOrder: true,
          fetchPacked: false,
          fetchShipped: false,
          fromDate: null,
          search: "",
          status: "NEW",
          toDate: new Date(),
        };
        const searchOrder = { ...newOrder };
        searchOrder.fromDate = _.isDate(searchOrder.fromDate)
          ? moment(searchOrder.fromDate).format("DD/MM/YYYY")
          : null;
        searchOrder.toDate = _.isDate(searchOrder.toDate)
          ? moment(searchOrder.toDate).format("DD/MM/YYYY")
          : null;
        res = await B2B_API.post(`order/search?page=${page}&pageSize=10`, {
          json: searchOrder,
        });
      } else if (activeTab === "RETURNED") {
        res = await B2B_API.get(
          `return/all/customer?orderStatus=${activeTab}&page=${page}&pageSize=10`
        );
      } else if (activeTab === "CANCELLED") {
        res = await B2B_API.get(
          `order/allByStatus?orderStatus=${activeTab}&page=${page}&pageSize=10`
        );
      } else {
        res = await B2B_API.get(
          `receipt/allByStatus?orderStatus=${activeTab}&page=${page}&pageSize=10`
        );
      }

      const data = await res?.json();


      const filteredData =
        data?.response?.content?.filter(
          (order) => order.orderStatus === activeTab
        ) || [];

      const sorted = _.sortBy(filteredData, "createdDate").reverse();
      setOrders(sorted);
      if (activeTab === "NEW" || activeTab === "CANCELLED") {
        setGrouplist((prev) => ({
          ...prev,
          ..._.groupBy(sorted, "orderNo"),
        }));
      } else {
        setGrouplist((prev) => ({
          ...prev,
          ..._.groupBy(sorted, "receiptNo"),
        }));
      }

      setHasMore(page < data?.response?.totalPages - 1);
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      stopLoading();
    }
  };
  const fetchAll = async () => {
    try {
      startLoading();
      const res = await B2B_API.get("dashboard/getAll").json();

      setOrder(res.customerOrders || []);
      setPayment(res.payments || []);
      setPaymentPage(0);
      setHasMorePayments(res.payments && res.payments.length === 15);
      setRecomend(res.suggestedPims || []);
      setCollectionTop(res?.collectionsTop || []);
      setCollectionBottom(res?.collectionBottom || []);

    } catch (error) {
      console.error("Error fetching recommended items:", error);
    } finally {
      stopLoading();
      setDashBoardGetAll(true);
    }
  };

  const fetchNextPayments = async () => {
    if (paymentLoading || !hasMorePayments) return;
    try {
      setPaymentLoading(true);
      const nextPage = paymentPage + 1;
      const res = await B2B_API.get(`dashboard/getPayments?page=${nextPage}&size=15`).json();
      if (res && res.content) {
        setPayment((prev) => {
          const existingIds = new Set(prev.map((item) => item.id));
          const newPayments = res.content.filter((item) => !existingIds.has(item.id));
          return [...prev, ...newPayments];
        });
        setPaymentPage(nextPage);
        setHasMorePayments(!res.last);
      } else {
        setHasMorePayments(false);
      }
    } catch (error) {
      console.error("Error fetching next payments:", error);
    } finally {
      setPaymentLoading(false);
    }
  };

  const featchProfile = async () => {
    startLoading();
    try {
      const res = await B2B_API.get("customer/profile").json();
      if (res?.response?.loyaltyId) {
        await fetchLoyalty(res.response.loyaltyId);
      }

      if (res?.response?.firstTimeLogin === true) {
        setChangePasswordOpened(true);
      }
      console.log(res, "res ss")
      setCustomerId(res?.response?.customerId);
      setProfile(res?.response);
    } catch (error) {
      console.error("Error fetching recommended items:", error);
    } finally {
      stopLoading();
    }
  }
  const handlePasswordChange = async () => {
    try {
      if (!oldPassword || !newPassword || !confirmPassword) {
        notify({ error: true, title: "Please fill in all fields." });
        return;
      }

      if (newPassword !== confirmPassword) {
        notify({ error: true, title: "New passwords do not match." });
        return;
      }

      const res = await B2B_API.post("customer/changePassword", {
        json: {
          customerId,
          currentPassword: oldPassword,
          newPassword,
        },
      }).json();

      if (res?.success === true || res?.response?.success === true) {
        notify({
          error: false,
          success: true,
          title: res?.message || "Password changed successfully",
        });
        featchProfile();
        setChangePasswordOpened(false);
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        notify({
          success: true,
          error: false,
          title: res?.message || "Password change failed",
        });
        featchProfile();
        setChangePasswordOpened(false);
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");

      }
    } catch (error) {
      console.error("Error changing password:", error);
      notify({
        error: true,
        title: error?.message || "Something went wrong",
      });
      featchProfile()
    }
  };


  const handleSalesmanDownload = () => {
    const isUat = window.location.origin.includes('uat') || window.location.origin.includes('localhost');

    const url = "https://play.google.com/store/apps/details?id=com.fabinsta";

    const link = document.createElement('a');
    link.href = url;
    link.download = "Buyer.apk";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const renderColorCode = (productVariants) => {
    if (productVariants && productVariants.length > 0) {
      const hexaColorCodes = productVariants.flatMap((item) =>
        item.variants?.filter((variant) => variant.hexaColorCode)
      );
      return (
        <div
          className={`colorchips ${_.size(hexaColorCodes) < 12 ? "borderable" : ""
            }`}
        >
          {_.map(hexaColorCodes, (hexa, index) => (
            <div
              key={index}
              className="colorchip"
              style={{ backgroundColor: hexa.hexaColorCode }}
            ></div>
          ))}
        </div>
      );
    } else {
      return <></>;
    }
  };

  const isNewArrival = (pim) => {
    const createdDate = new Date(pim.createdDate); // assuming createdDate is a valid date string or timestamp
    const currentDate = new Date();
    const diffTime = currentDate - createdDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    return diffDays <= 5;
  };



  return (
    <div className="dashboard-container">
      {loading && (
        <div className="loading-container">
          <Loader color={"var(--primary)"} type="oval" />
        </div>
      )}
      {/* Welcome Section */}
      <div className="welcome-loyalty">
        <div className="card-welcome" style={{ display: "flex", width: profile?.loyaltyId ? "60%" : "100%" }}>
          <div style={{ flex: 1 }}>
            <div className="welcome-title-row">
              <h2 className="card-title" style={{ margin: 0 }}>
                Welcome back{" "}
                <span
                  style={{ fontWeight: "bold", color: "#8BC53F" }}
                  className="name"
                >
                  {profile?.name}
                </span>{" "}
              </h2>
              <div className="card-button-down-app-mobile" style={{ position: "relative", flexShrink: 0 }}>
                <div className='down-app-flexx' onClick={handleSalesmanDownload} >
                  <div className="mob-app-dow-buyer">Buyer App</div>
                  <img src={`${downloadApp}?time=${Date.now()}`} alt="down_app" className="down-app" />
                </div>
              </div>
            </div>
            <p className="card-subtext" style={{ marginTop: "8px", marginBottom: 0 }}>
              You last visited {timeSince(profile?.latestLoginDate)} — here's what's
              new for you.
            </p>
          </div>
          <div className="card-button-down-app" style={{ position: "relative", flexShrink: 0 }}>
            <div className="down-app-msg">Download Mobile app</div>
            <div className='down-app-flexx' onClick={handleSalesmanDownload} >
              <div className="mob-app-dow-buyer">Buyer App</div>
              <img src={`${downloadApp}?time=${Date.now()}`} alt="down_app" className="down-app" />
            </div>
          </div>
        </div>

        {/* .                     loyalty cart */}
        {profile?.loyaltyId && (
          <div className="card-loyalty" style={{ position: "relative" }}>
            <div style={{ width: "100%" }}>
              <div className="loyalty-header">
                <h2 className="loyalty-title">Your <span style={{ color: "#8BC53F" }}>
                  {loyalty?.loyaltyName}
                </span> Loyalty</h2>
              </div>

              <div className="best-offer-box">
                <div className="offer-line">
                  You have earned <strong> {loyalty?.openingPoints}</strong> points , keep purchasing to get more points
                </div>
                <div className="offer-line-ebc">
                  <div className="earned-points">
                    <div style={{ display: "flex", flexDirection: isMobile ? "row" : "column", justifyContent: "space-between", alignItems: "center", width: "100%", fontSize: "13px" }}>
                      <span style={{ fontWeight: "600", color: "var(--text-muted)" }}>Earned Points</span>
                      <span style={{ fontWeight: "700", color: "var(--primary)" }}>{customerWalletDetails?.totalWalletAmount?.toFixed(2) || 0}</span>
                    </div>
                  </div>
                  <div className="earned-points">
                    <div style={{ display: "flex", flexDirection: isMobile ? "row" : "column", justifyContent: "space-between", alignItems: "center", width: "100%", fontSize: "13px" }}>
                      <span style={{ fontWeight: "600", color: "var(--text-muted)" }}>Burned Points</span>
                      <span style={{ fontWeight: "700", color: "#ef4444" }}>{customerWalletDetails?.totalAdjustedAmount?.toFixed(2) || 0}</span>
                    </div>
                  </div>
                  <div className="earned-points">
                    <div style={{ display: "flex", flexDirection: isMobile ? "row" : "column", justifyContent: "space-between", alignItems: "center", width: "100%", fontSize: "13px" }}>
                      <span style={{ fontWeight: "600", color: "var(--text-muted)" }}>Closing Points</span>
                      <span style={{ fontWeight: "700", color: "#16a34a" }}>{(Number(customerWalletDetails?.totalWalletAmount) - Number(customerWalletDetails?.totalAdjustedAmount)).toFixed(2) || 0}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>

      <div>
        {!dashBoardGetAll ? null : collectionTop.length === 0 ? (
          <div>
            <h1>No recommendations available at the moment</h1>
          </div>
        ) : (
          <div className="grid-rec" style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
            {collectionsArray.map((collection) => (
              <div
                className="card animate-fade-in-up delay-1"
                key={collection.collectionId}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                  className="card-title"
                >
                  <h3 className="section-title"
                  >
                    {collection.collectionName}
                  </h3>
                  <span
                    className="view-orders"
                    onClick={() => navigate("/fabrics", { state: { collectionId: collection.collectionId, page: 0 } })}
                  >
                    View All
                  </span>
                </div>

                <Carousel
                  withIndicators={false}
                  slideSize={isMobile ? "230px" : "200px"}
                  slidesToScroll={isMobile ? 1 : 2}
                  slideGap={10}
                  align="start"
                >
                  {collection.pims?.map((pim, index) => (
                    <Carousel.Slide key={pim.pimId} style={{ display: 'flex' }}>
                      <Card
                        className="grid-recc"
                        key={index}
                        shadow="sm"
                        padding={0}
                        radius="md"
                        withBorder
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          overflow: "hidden",
                          flex: 1,
                        }}
                        onClick={() => {
                          navigate(pim.landingUrl)
                        }}
                      >
                        {isNewArrival(pim) && (
                          <span className="badge-new-arrival">NEW</span>
                        )}
                        {/* <img
                                         className="product-image"
                                         src={`${BASE_URL.replace("/api", "")}${pim.image}`}
                                         alt="Norway"
                                       /> */}
                        <img
                          className="product-img"
                          src={`${BASE_URL.replace("/api", "")}${pim.image}?time=${Date?.now()}`}
                          // src={silkimg}
                          alt="Product"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = FALLBACK_IMAGE;
                            e.target.style.border = "1px solid #cbd5e1";
                          }}
                        />
                        {pim?.inSwatchCart && !pim?.inSampleCart && <div className="overlay-text">Added in Swatch Cart</div>}
                        {pim?.inSampleCart && <div className="overlay-text">Added in Sample Cart</div>
                        }

                        <div style={{ padding: "12px" }}>
                          {renderColorCode(pim.pimVariants)}
                          <div>
                            <div
                              style={{
                                color: "#788191",
                                fontWeight: "500",
                                fontSize: "12px",
                              }}
                            >
                              {pim.articleCode}
                            </div>
                            <div
                              style={{
                                fontWeight: "600",
                              }}
                            >
                              {pim?.articleName}
                            </div>
                          </div>
                          <div className="quality-price">
                            <b className="price-container">
                              &#8377; {pim.channelPrice}
                            </b>
                          </div>
                          <div className="quality-info">
                            <div className="contents">
                              <div className="f-600 item">
                                <div>{pim.fabricContent?.value}</div>
                              </div>
                            </div>
                          </div>
                          <div style={{ fontSize: "11px" }}>
                            <span className="m-r-0 weight-span">
                              <span>{pim?.metrics?.weight}</span>
                              <span>gsm</span>
                            </span>
                            <span className="m-l-4 m-r-4 weight-span">.</span>
                            <span className='weight-span'>{pim.attributes['Fabric Type']?.name}</span>
                          </div>
                          <div
                            className="badges-quality m-t-8"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div className="badge-type">
                              <img className="badge-img" src={`${badge}?time=${Date.now()}`} alt="Badge" />
                              {_.size(pim.pimVariants)}
                            </div>
                            <div></div>
                          </div>
                        </div>
                      </Card>
                    </Carousel.Slide>
                  ))}

                </Carousel>
              </div>
            ))}
          </div>
        )}
      </div>

      <div>
        {/* <h1 className="section-title" style={{ color: "#8BC53F" }}>Collection Bottom</h1> */}
        {!dashBoardGetAll ? null : collectionTop.length === 0 ? (
          <div>
            <h1>No recommendations available at the moment</h1>
          </div>
        ) : (
          <div className="grid-rec" style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
            {collectionsBottomArray.map((collection) => (
              <div
                className="card animate-fade-in-up delay-2"
                key={collection.collectionId}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                  className="card-title"
                >
                  <h3 className="section-title"
                  >
                    {collection.collectionName}
                  </h3>
                  <span
                    className="view-orders"
                    onClick={() => navigate("/fabrics", { state: { collectionId: collection.collectionId, page: 0 } })}
                  >
                    View All
                  </span>
                </div>

                <Carousel
                  withIndicators={false}
                  slideSize={isMobile ? "230px" : "200px"}
                  slidesToScroll={isMobile ? 1 : 2}
                  slideGap={10}
                  align="start"
                >
                  {collection.pims?.map((pim, index) => (
                    <Carousel.Slide key={pim.pimId} style={{ display: 'flex' }}>
                      <Card
                        className="grid-recc"
                        key={index}
                        shadow="sm"
                        padding={0}
                        radius="md"
                        withBorder
                        onClick={() => {
                          navigate(pim.landingUrl)
                        }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          overflow: "hidden",
                          flex: 1,
                        }}
                      >
                        {isNewArrival(pim) && (
                          <span className="badge-new-arrival">NEW</span>
                        )}
                        {/* <img
                                         className="product-image"
                                         src={`${BASE_URL.replace("/api", "")}${pim.image}`}
                                         alt="Norway"
                                       /> */}
                        <img
                          className="product-img"
                          src={`${BASE_URL.replace("/api", "")}${pim.image}?time=${Date?.now()}`}
                          // src={silkimg}
                          alt="Product"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = FALLBACK_IMAGE;
                            e.target.style.border = "1px solid #cbd5e1";
                          }}
                        />
                        {pim?.inSwatchCart && !pim?.inSampleCart && <div className="overlay-text">Added in Swatch Cart</div>}
                        {pim?.inSampleCart && <div className="overlay-text">Added in Sample Cart</div>
                        }

                        <div style={{ padding: "12px" }}>
                          {renderColorCode(pim.pimVariants)}
                          <div>
                            <div
                              style={{
                                color: "#788191",
                                fontWeight: "500",
                                fontSize: "12px",
                              }}
                            >
                              {pim.articleCode}
                            </div>
                            <div
                              style={{
                                fontWeight: "600",
                              }}
                            >
                              {pim?.articleName}
                            </div>
                          </div>
                          <div className="quality-price">
                            <b className="price-container">
                              &#8377; {pim.channelPrice}
                            </b>
                          </div>
                          <div className="quality-info">
                            <div className="contents">
                              <div className="f-600 item">
                                <div>{pim.fabricContent?.value}</div>
                              </div>
                            </div>
                          </div>
                          <div style={{ fontSize: "11px" }}>
                            <span className="m-r-0 weight-span">
                              <span>{pim?.metrics?.weight}</span>
                              <span>gsm</span>
                            </span>
                            <span className="m-l-4 m-r-4 weight-span">.</span>
                            <span className='weight-span'>{pim.attributes['Fabric Type']?.name}</span>
                          </div>
                          <div
                            className="badges-quality m-t-8"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div className="badge-type">
                              <img className="badge-img" src={`${badge}?time=${Date.now()}`} alt="Badge" />
                              {_.size(pim.pimVariants)}
                            </div>
                            <div></div>
                          </div>
                        </div>
                      </Card>
                    </Carousel.Slide>
                  ))}

                </Carousel>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Recommendations */}
      <div className="card animate-fade-in-up delay-3">
        <h3 className="section-title">Recommended for You</h3>

        {!dashBoardGetAll ? null : recomend.length === 0 ? (
          <div className="text-center m-t-96 f-13 f-500">
            No recommendations available at the moment
          </div>
        ) : recomend.length > 0 ? (
          <Carousel
            withIndicators={false}
            slideSize={isMobile ? "230px" : "200px"}
            slidesToScroll={isMobile ? 1 : 2}
            slideGap={10}
            align="start"
          >
            {recomend.map((item, index) => (
              <Carousel.Slide key={item.id || item.productId || index} style={{ display: 'flex' }}>
                <Card
                  className="dash-card-layout"
                  shadow="sm"
                  padding={0}
                  radius="md"
                  withBorder
                  onClick={() => navigate(item.landingUrl)}
                >
                  <div className="dash-card-img-wrapper">
                    <span
                      className="heart-icon dash-heart-icon-wrapper"
                      style={{ color: "#8BC53F", fontSize: "12px" }}
                    ></span>
                    <img
                      className="dash-card-img img-lg"
                      src={`${BASE_URL + item?.image.replace("/api", "")}?time=${Date.now()}`}
                      alt={item.articleName}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = FALLBACK_IMAGE;
                        e.target.style.border = "1px solid #cbd5e1";
                      }}
                    />
                  </div>
                  <div className="dash-card-content">
                    {renderColorCode(item?.pimVariants)}
                    <div>
                      <div className="dash-text-muted md">
                        {item?.articleCode}
                      </div>
                      <div className="dash-text-bold">
                        {item?.articleName}
                      </div>
                    </div>
                    <div className="quality-price">
                      <b className="price-container">
                        &#8377; {item?.channelPrice}
                      </b>
                    </div>
                    <div className="quality-info">
                      <div className="contents">
                        <div className="f-600 item">
                          <div>{item?.fabricContent?.value}</div>
                        </div>
                      </div>
                    </div>
                    <div style={{ fontSize: "11px" }}>
                      <span className="m-r-0 weight-span">
                        <span>{item?.metrics?.weight}</span>
                        <span>gsm</span>
                      </span>
                      <span className="m-l-4 m-r-4 weight-span">.</span>
                      <span className='weight-span'>{item?.attributes['Fabric Type']?.name}</span>
                    </div>
                    <div className="badges-quality m-t-8 dash-flex-between dash-card-footer">
                      <div className="badge-type">
                        <img className="badge-img" src={`${badge}?time=${Date.now()}`} alt="Badge" />
                        {_.size(item?.pimVariants)}
                      </div>
                      <div></div>
                    </div>
                  </div>
                </Card>
              </Carousel.Slide>
            ))}
          </Carousel>
        ) : null}
      </div>

      {/* Order Summary */}
      <div className="card1 animate-fade-in-up delay-4">
        <div className="card-order">
          <div
            style={{ display: "flex", justifyContent: "space-between" }}
            className="card-title"
          >
            <h3 className="section-title">Your Orders</h3>
            <span
              className="view-orders"
              onClick={() => navigate("/place-Orders")}
            >
              View All
            </span>
          </div>
          {!dashBoardGetAll ? null : order?.length === 0 ? (
            <div className="text-center m-t-96 f-13 f-500">
              No orders available at the moment
            </div>
          ) : (
            <div className="grid-ordered">
              <Carousel
                withIndicators={false}
                slideSize={isMobile ? "248px" : "155px"}
                slidesToScroll={isMobile ? 1 : 2}
                slideGap={10}
                align="start"
              >
                {order.map((orderItem) => (
                  <Carousel.Slide key={orderItem.id} style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <Card
                      className="dash-card-layout"
                      shadow="sm"
                      padding={0}
                      radius="md"
                      withBorder
                      onClick={() => navigate(navigateToOrders(orderItem.orderType))}
                    >
                      <div className="dash-card-img-wrapper">
                        <img
                          className="dash-card-img img-sm"
                          src={BASE_URL + orderItem?.items[0]?.image?.replace("/api", "")}
                          alt=""
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = FALLBACK_IMAGE;
                            e.target.style.border = "1px solid #cbd5e1";
                          }}
                        />
                      </div>
                      <div className="dash-card-content" style={{ justifyContent: "space-between" }}>
                        <div className="dash-flex-between">
                          <span className="dash-text-bold">{orderItem?.orderNo}</span>
                          {orderItem?.orderType != null && <span className="badge-type-order">{orderItem?.orderType}</span>}
                        </div>
                        <div className="dash-text-muted md">Status : <span style={{ color: "#3b82f6" }}>{orderItem?.orderStatus === "NEW" ? "New" : "Processed"} </span></div>
                        <div title={orderItem?.items?.[0]?.productName} className="dash-text-bold md" style={{ minHeight: "20px" }}>
                          {orderItem?.items?.[0]?.productName ? (orderItem.items[0].productName.length > 18 ? orderItem.items[0].productName.substring(0, 18) + "..." : orderItem.items[0].productName) : "\u00A0"}
                        </div>
                        <div className="dash-card-footer" style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                          <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                            <span style={{ color: "#16a34a", fontWeight: "bold", fontSize: "14px" }}>
                              ₹ {orderItem?.grossTotal?.toFixed(2) || "0.00"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Carousel.Slide>
                ))}
              </Carousel>
            </div>
          )}
        </div>
        <div className="card-payment">
          <div
            style={{ display: "flex", justifyContent: "space-between" }}
            className="card-title"
          >
            <h3 className="section-title">Payment Due</h3>
          </div>
          {!dashBoardGetAll ? null : payment?.length === 0 ? (
            <div className="text-center m-t-96 f-13 f-500">
              No payment due at the moment
            </div>
          ) : (
            <div className="grid-ordered">
              <Carousel
                withIndicators={false}
                slideSize={isMobile ? "248px" : "155px"}
                slidesToScroll={isMobile ? 1 : 2}
                slideGap={10}
                align="start"
                onSlideChange={(index) => {
                  if (index >= payment.length - (isMobile ? 4 : 8)) {
                    fetchNextPayments();
                  }
                }}
              >
                {payment.map((orderItem) => (
                  <Carousel.Slide key={orderItem.id} style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <Card
                      className="dash-card-layout"
                      shadow="sm"
                      padding={0}
                      radius="md"
                      withBorder
                      onClick={() => navigate(`/order-Details?orderNo=${orderItem.orderNo || orderItem.referenceNo}`)}
                    >
                      <div className="dash-card-img-wrapper">
                        <img
                          className="dash-card-img img-sm"
                          src={BASE_URL + (orderItem?.image || orderItem?.productImage || orderItem?.items?.[0]?.image)?.replace("/api", "")}
                          alt=""
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = FALLBACK_IMAGE;
                            e.target.style.border = "1px solid #cbd5e1";
                          }}
                        />
                      </div>
                      <div className="dash-card-content">
                        <div className="dash-flex-between">
                          <span className="dash-text-bold">{orderItem.orderNo || orderItem.referenceNo}</span>
                          {orderItem?.orderType != null && <span className="badge-type-payment">{orderItem.orderType}</span>}
                        </div>
                        <div title={orderItem?.productName} className="dash-text-bold md" style={{ minHeight: "20px" }}>
                          {orderItem?.productName ? (orderItem.productName.length > 10 ? orderItem.productName.substring(0, 10) + "..." : orderItem.productName) : "\u00A0"}
                        </div>
                        <div className="dash-card-footer" style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                          <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                            <span style={{ color: "#ef4444", fontWeight: "bold", fontSize: "14px" }}>
                              <span style={{ color: "#000000", fontWeight: "bold", fontSize: "14px" }}>Due : </span> ₹ {orderItem?.amountNeedToBePaid?.toFixed(2) || "0.00"}
                            </span>
                          </div>
                          <Button
                            className="dash-btn-pay"
                            size="xs"
                            style={{ backgroundColor: "#8BC53F", height: "30px", width: "100%" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              paymentOpen(orderItem);
                            }}
                          >
                            Pay Now
                          </Button>
                        </div>
                      </div>
                    </Card>
                  </Carousel.Slide>
                ))}
              </Carousel>
            </div>)}
        </div>
        <Modal
          opened={paymentOpened}
          onClose={paymentClose}
          title="Payment Details"
          centered
          overlayProps={{
            backgroundOpacity: 0.55,
            blur: 3
          }}
          classNames={{
            content: "custom-modal-content",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <PayNow
            payment={salesOrder.payment}
            salesOrder={salesOrder}
            setSalesOrder={setSalesOrder}
            acceptPayment1={AcceptPaymentt}
            paymentClose={paymentClose}
            acceptPayment={(v) => {
              acceptPayment({
                orderNo: v?.referenceNo,
                receiptNo: v?.adjustmentType === "DC" ? v?.referenceNo : null
              })
              paymentClose()
            }}
            customerId={salesOrder?.customerId}
          />
        </Modal>
      </div>
      {/* Wishlist */}
      <div className="card animate-fade-in-up delay-4">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3 className="section-title">Your Wishlist</h3>
          <span
            className="view-orders"
            onClick={() => navigate("/wishList")}
          >
            View All
          </span>
        </div>
        {wishList?.length === 0 ? (
          <div className="text-center m-t-96 f-13 f-500">
            There is No Products in your wishlist
          </div>
        ) : (
          <Carousel
            withIndicators={false}
            slideSize={isMobile ? "250px" : "200px"}
            slidesToScroll={isMobile ? 1 : 2}
            slideGap={10}
            align="start"
          >
            {wishList.map((wishItem) => {
              const pim = wishItem?.pim;
              const variant = pim?.pimVariants?.[0];
              const colorVariant = variant?.variants?.find(v => v.type === 'Colour');
              const articleName = pim?.product?.articleName;
              const pimUrl = pim?.landingUrl;
              const image = variant?.image;
              const hexaColorCode = colorVariant?.hexaColorCode;
              const colorValue = colorVariant?.value;
              const sellingPrice = variant?.sellingPrice;
              return (
                <Carousel.Slide key={wishItem?.id} style={{ display: 'flex' }}>
                  <Card
                    className="dash-card-layout"
                    shadow="sm"
                    padding={0}
                    radius="md"
                    withBorder
                    onClick={() => navigate(pimUrl)}
                  >
                    <div className="dash-card-img-wrapper">
                      <img
                        className="dash-card-img img-lg"
                        src={BASE_URL + image?.replace("/api", "")}
                        alt=""
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = FALLBACK_IMAGE;
                          e.target.style.border = "1px solid #cbd5e1";
                        }}
                      />
                      <div className="dash-heart-icon-wrapper">
                        <ActionIcon
                          size={32}
                          variant="transparent"
                          aria-label="Wishlist Icon"
                          style={{
                            borderRadius: "9999px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backdropFilter: "blur(8px)",
                            WebkitBackdropFilter: "blur(8px)",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                            transition: "all 0.3s ease",
                            border: "none",
                            backgroundColor: "rgba(255,255,255,0.8)",
                            cursor: "default",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.1)";
                            e.currentTarget.style.backgroundColor = "#ffffff";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                            e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.8)";
                          }}
                          onMouseDown={(e) => {
                            e.currentTarget.style.transform = "scale(0.95)";
                          }}
                          onMouseUp={(e) => {
                            e.currentTarget.style.transform = "scale(1.1)";
                          }}
                        >
                          <IconHeart
                            style={{
                              width: "20px",
                              height: "20px",
                              color: "#ef4444",
                              fill: "#f80b0b",
                              transition: "all 0.3s ease",
                            }}
                          />
                        </ActionIcon>
                      </div>
                    </div>
                    <div className="dash-card-content">
                      <div className="dash-text-bold md">
                        {articleName?.split('/')[0]?.trim()}
                      </div>
                      <div style={{ fontSize: "13px", display: "flex", alignItems: "center" }}>
                        <span style={{ color: "#64748b", marginRight: "6px" }}>Color:</span>
                        <span className="color-dot" style={{ background: hexaColorCode, width: "12px", height: "12px", borderRadius: "50%", display: "inline-block", marginRight: "4px" }}></span>
                        <span title={colorValue} style={{ fontWeight: "500", color: "#475569" }}>
                          #{`${colorValue && colorValue.length > 10 ? colorValue.substring(0, 10) + '...' : colorValue}`}
                        </span>
                      </div>
                      <div className="dash-card-footer">
                        <span className="price" style={{ color: "#16a34a", fontWeight: "700", fontSize: "15px" }}>
                          ₹ {sellingPrice?.toFixed(2) || 0}
                        </span>
                      </div>
                    </div>
                  </Card>
                </Carousel.Slide>
              );
            })}
          </Carousel>
        )}


        <Modal
          opened={chanagePasswordOpened}
          title="Change Password"
          centered
          overlayProps={{ backgroundOpacity: 0.3, blur: 2 }}
          classNames={{
            content: "custom-modal-content",
          }}
        >
          <Stack>
            <PasswordInput
              label="Old Password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.currentTarget.value)}
              visibilityToggleIcon={({ reveal }) =>
                reveal ? <IconEyeOff size={16} /> : <IconEye size={16} />
              }
              required
            />

            <PasswordInput
              label="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.currentTarget.value)}
              visibilityToggleIcon={({ reveal }) =>
                reveal ? <IconEyeOff size={16} /> : <IconEye size={16} />
              }
              required
            />

            <PasswordInput
              label="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.currentTarget.value)}
              visibilityToggleIcon={({ reveal }) =>
                reveal ? <IconEyeOff size={16} /> : <IconEye size={16} />
              }
              required
            />

            <div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
              {/* <Button variant="default" onClick={closeSecondModal}>
                Cancel
              </Button> */}
              <Button
                style={{ color: "white", backgroundColor: "#8BC53F", width: "30%", marginLeft: "8rem" }}
                onClick={handlePasswordChange}
              >
                Change
              </Button>
              <div style={{ color: "red", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px" }}><span style={{ color: "grey", marginRight: "0.2rem", fontSize: "12px" }}>NOTE :</span>can't close without changing password</div>
            </div>

          </Stack>
        </Modal>

      </div>
      {/* <div className="card">
        <h3 className="section-title">Your Rewards</h3>
        <p>
          You have <span className="highlight">320 points</span>. Redeem now or
          earn 180 more for ₹100 off.
        </p>
      </div> */}
      {/* <div className="btns-btn-primary">
        <p style={{ color: "white", fontSize: "20px", fontWeight: "bold" }}>
          Explore More{" "}
        </p>
        <button className="button" onClick={() => navigate("/fabrics")}>
          Fabric Library
        </button>
      </div> */}

      {/* Exclusive Offers */}
      {/* <div className="offer-box">
        <p>🎁 No Offers Available</p>
      </div> */}
    </div >
  );
};

export default CustomerDashboard;
